import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useProfile } from "@/features/profile/services";
import { Spinner } from "@/shared/components/ui/spinner";
import { resolveRouteForProfileMembership } from "@/features/plan/lib/membership-flow";

type KycMembershipGuardProps = {
  children: ReactElement;
};

const KycMembershipGuard = ({ children }: KycMembershipGuardProps) => {
  const {
    data: profile,
    isLoading,
    isError,
  } = useProfile({
    staleTime: 30_000,
    retry: 1,
  });

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center py-10">
        <div className="flex items-center gap-3 text-sm text-white/70">
          <Spinner className="size-5" />
          Checking membership...
        </div>
      </div>
    );
  }

  if (!isError) {
    const membershipRoute = resolveRouteForProfileMembership(
      profile?.membership ?? null
    );

    if (membershipRoute) {
      return <Navigate to={membershipRoute} replace />;
    }
  }

  return children;
};

export default KycMembershipGuard;
